import React, { useEffect, useState } from "react";
import SidebarNav from "../sidebar";

import { useDispatch, useSelector } from "react-redux";
import { updatePassword, updateProfile } from "../../../service/api";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import { TextField } from "@mui/material";
import actions from "../../../redux/user/actions";
import { Spinner } from "react-bootstrap";
import {
  sanitizeInput,
  validateFile,
  validatePassword,
} from "../../../config/validation";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const UserProfile = () => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const history = useHistory();

  const [profileImage, setProfileImage] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState();
  const [profilePhotoShow, setProfilePhotoShow] = useState();
  const [userName, setUserName] = useState(user?.user?.name);
  const [loading, setLoading] = useState(false);

  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [cnewPass, setCnewPass] = useState("");
  const [passLoading, setPassLoading] = useState(false);

  useEffect(() => {
    if (user?.user?.profileImage) {
      setProfileImage(true);
    }
  }, [user]);

  const handlePassword = () => {
    if (!oldPass) {
      toast.error("Enter Old Password", { toastId: 'profile-password-validation-error' });
      return;
    }
    if (!cnewPass) {
      toast.error("Enter New Password", { toastId: 'profile-password-validation-error' });
      return;
    }

    // Validate new password format
    const passwordError = validatePassword(cnewPass);
    if (passwordError) {
      toast.error(passwordError, { toastId: 'profile-password-validation-error' });
      return;
    }

    // Check if old and new passwords are the same
    if (oldPass === cnewPass) {
      toast.error("New password cannot be the same as old password", { toastId: 'profile-password-validation-error' });
      return;
    }

    let body = {
      oldPassword: oldPass,
      password: cnewPass,
    };
    setPassLoading(true);
    updatePassword(body)
      .then((res) => {
        if (res?.status) {
          localStorage.clear();
          dispatch(actions.setLoggedIn(false));
          dispatch(actions.setUser(null));
          dispatch(actions.setToken(null));
          history.push("/");
          toast.success("Password changed successfully", { toastId: 'profile-password-success' });
        } else {
          toast.error(res?.message, { toastId: 'profile-password-error' });
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message, { toastId: 'profile-password-error' });
      })
      .finally(() => {
        setPassLoading(false);
      });
  };

  const handleProfile = () => {
    if (!userName || !userName.trim()) {
      toast.error("Please enter username", { toastId: 'profile-username-validation-error' });
      return;
    }

    // Sanitize the username before submission
    const sanitizedName = sanitizeInput(userName);
    if (!sanitizedName.trim()) {
      toast.error("Please enter a valid username", { toastId: 'profile-username-validation-error' });
      return;
    }

    const formdata = new FormData();

    formdata.append("name", sanitizedName.trim());
    profilePhoto && formdata.append("profile", profilePhoto);
    setLoading(true);
    updateProfile(user?.user?._id, formdata)
      .then((res) => {
        console.log("%c Line:110 🍰 res", "color:#6ec1c2", res);
        if (res?.status) {
          dispatch(actions.setUser(res?.data));
          toast.success(res?.message, { toastId: 'profile-username-success' });
        }
      })
      .catch((e) => {
        console.log("%c Line:100 🍿 e", "color:#33a5ff", e);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <SidebarNav />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Profile</h3>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              {" "}
              <div className="tab-content profile-tab-cont">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">Profile Details</h5>
                    <div className="row">
                      <div className="col-md-10 col-lg-6">
                        <form>
                          <div className="form-group">
                            <label>Username</label>
                            <input
                              type="text"
                              className="form-control"
                              value={userName}
                              onChange={(e) => {
                                setUserName(e.target.value);
                              }}
                            />
                          </div>
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              type="email"
                              className="form-control"
                              value={user?.user?.email}
                              readOnly
                            />
                          </div>
                          <div>
                            <div className="form-group">
                              <label>Profile Photo</label>
                              {!profileImage ? (
                                <TextField
                                  className="form-control"
                                  style={{
                                    height: "100%",
                                  }}
                                  type="file"
                                  inputProps={{
                                    accept:
                                      "image/jpeg,image/png,image/gif,image/bmp,image/webp",
                                  }}
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    const error = validateFile(file);
                                    if (error) {
                                      toast.error(error, { toastId: 'profile-error' });
                                      e.target.value = null;
                                      return;
                                    }
                                    setProfilePhoto(file);
                                    setProfileImage(true);
                                    if (file) {
                                      const reader = new FileReader();
                                      reader.onload = () => {
                                        setProfilePhotoShow(reader.result);
                                      };
                                      reader.readAsDataURL(file);
                                    }
                                  }}
                                  name="topImage"
                                  id="topImage"
                                />
                              ) : (
                                <div className="img-incoming-div">
                                  {" "}
                                  <img
                                    src={
                                      profilePhotoShow
                                        ? profilePhotoShow
                                        : user?.user?.profileImage
                                    }
                                    alt=""
                                    draggable="false"
                                    onContextMenu={(e) => e.preventDefault()}
                                    className="img-incoming"
                                  />
                                  <MdDelete
                                    onClick={() => {
                                      setProfileImage(false);
                                      setProfilePhotoShow();
                                      setProfilePhoto();
                                    }}
                                    className={`img-incoming-icon display-flex`}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleProfile}
                            disabled={loading}
                          >
                            {loading ? <Spinner size="sm" /> : "Save Changes"}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-content profile-tab-cont">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">Change Password</h5>
                    <div className="row">
                      <div className="col-md-10 col-lg-6">
                        <form>
                          <div className="form-group">
                            <label>Old Password</label>
                            <input
                              type="password"
                              className="form-control"
                              value={oldPass}
                              onChange={(e) => {
                                setOldPass(sanitizeInput(e.target.value));
                              }}
                            />
                          </div>
                          {/* <div className="form-group">
                            <label>New Password</label>
                            <input
                              type="password"
                              className="form-control"
                              value={newPass}
                              onChange={(e) => {
                                setNewPass(e.target.value);
                              }}
                            />
                          </div> */}
                          <div className="form-group">
                            <label>New Password</label>
                            <input
                              type="password"
                              className="form-control"
                              value={cnewPass}
                              onChange={(e) => {
                                setCnewPass(sanitizeInput(e.target.value));
                              }}
                            />
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handlePassword}
                            disabled={passLoading}
                          >
                            {passLoading ? (
                              <Spinner size="sm" />
                            ) : (
                              "Save Changes"
                            )}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* /Page Wrapper */}
    </>
  );
};

export default UserProfile;
